import React, { ChangeEvent, useState } from "react";
// import { useParams } from "react-router-dom";
import { Collection } from "./interfaces";
import {
  getCollectedListing,
  getHumanCompanyName,
  getSpreadsheetURL,
} from "./functions";
import ExperienceCollection from "./index-collection";
import { IExpIndexProps } from ".";
import useAnalytics from "../hooks/useAnalytics";
// import { useLoaderData } from "react-router-dom";

const ExperienceListing = ({ companyName }: IExpIndexProps): JSX.Element => {
  const [search, setSearch] = useState("");
  const pageTitle = `AR Experiences for ${getHumanCompanyName(companyName)}`;
  document.title = pageTitle;
  // const allExperiences = useLoaderData() as Experience[];
  // console.log('Loaded all experiences', allExperiences);
  useAnalytics();
  const collectedData = getCollectedListing(companyName);
  return (
    <div className="page">
      <section className="brand3d-page-heading">
        <h1 className="brand3d-page-title">
          {pageTitle}
          <a
            className="button"
            href={getSpreadsheetURL(companyName)}
            target="_blank"
            rel="noreferrer"
          >
            Download Spreadsheet
          </a>
        </h1>
        <p>
          <input
            type="text"
            name="search"
            className="search-field"
            placeholder="Search"
            value={search}
            onChange={(event: ChangeEvent<HTMLInputElement>): void => {
              setSearch(event.target.value);
            }}
          />
        </p>
      </section>
      {collectedData.map(
        (collection: Collection): JSX.Element => (
          <ExperienceCollection
            key={`collection-${collection.title.replace(/\W/i, "-")}`}
            companyName={companyName}
            collection={collection}
            search={search}
          />
        ),
      )}
    </div>
  );
};

export default ExperienceListing;
